import React from "react";
import Blogs from "./Blogs";
import Ongoing from "./Ongoing";
import "./down.scss";

const Down = () => {
  return (
    <div className="mainDown">
      <div className="left">
        <Ongoing />
        <Ongoing />
        <Ongoing />
      </div>

      <div className="right">
        <Blogs />
      </div>
    </div>
  );
};

export default Down;
